import api from '../services';

// Shared by class components (SequenceDetails, OfferActionDetail, OfferWallAdDetails) that can't
// use the useFeatures() React-Query hook (views/FeatureToggles/queries.js) since hooks can't be
// called from class components.
export async function resolveFeatureFlag(featureName) {
  try {
    const res = await api.get('features');
    const feature = res.data?.find((f) => f.name === featureName);
    return feature?.enabled === true;
  } catch {
    return false;
  }
}
